import React from 'react';

// Volto Light Theme replaces the search block's layouts with one
// (facetsTopSide). Search blocks saved earlier name another layout, e.g.
// facetsLeftSide on /events/upcoming; Volto finds no layout for those and the
// whole page fails with a 500. A layout the site no longer has is dropped, so
// the default is used.
export const withKnownVariation = (data, variations = []) =>
  data?.variation && !variations.some(({ id }) => id === data.variation)
    ? { ...data, variation: undefined }
    : data;

export default function install(config) {
  const search = config.blocks.blocksConfig.search;
  if (!search?.view) return config;

  const SearchView = search.view;
  search.view = (props) => (
    <SearchView
      {...props}
      data={withKnownVariation(props.data, search.variations)}
    />
  );
  return config;
}
